import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { ClientLink } from "@dto/ClientLink";
import { convertToCamel } from "@lib/convertToCamel";
export interface ClientLinksState {
  kiosk: {
    priorityClientLinks: ClientLink[];
    nonPriorityClientLinks: ClientLink[];
  };
}

const initialState: ClientLinksState = {
  kiosk: {
    priorityClientLinks: convertToCamel(
      VisitWidget.store.kioskPriorityClientLinks,
    ),
    nonPriorityClientLinks: convertToCamel(
      VisitWidget.store.kioskNonPriorityClientLinks,
    ),
  },
};

export const clientLinksSlice = createSlice({
  name: "clientLinks",
  initialState,
  reducers: {},
});

export const selectKioskClientLinks = (state: RootState) => {
  return state.clientLinks.kiosk;
};

// eslint-disable-next-line import/no-default-export
export default clientLinksSlice.reducer;
